/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DailyNavGPCApproach } from '../models/DailyNavGPCApproach';
import type { DailyNavRecordUpdate } from '../models/DailyNavRecordUpdate';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DailyNavService {
  /**
   * The GPC approaches (and their non-deleted comps) for one company
   * measurement date, offered up as the source list for the "copy from GPC"
   * Daily NAV comp picker. Scoped solely by the company measurement date --
   * which already identifies the company and firm -- so firm/company ids are
   * not part of the route. Firm access is enforced off the CMD's owning firm.
   * @param companyMeasurementDateId
   * @param page A page number within the paginated result set.
   * @returns DailyNavGPCApproach
   * @throws ApiError
   */
  public static apiDailyNavCompanyMeasurementDatesGpcApproachesList(
    companyMeasurementDateId: string,
    page?: number
  ): CancelablePromise<Array<DailyNavGPCApproach>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/daily-nav/company-measurement-dates/{company_measurement_date_id}/gpc-approaches/',
      path: {
        company_measurement_date_id: companyMeasurementDateId,
      },
      query: {
        page: page,
      },
    });
  }
  /**
   * @param id A unique integer value identifying this daily nav record.
   * @param data
   * @returns DailyNavRecordUpdate
   * @throws ApiError
   */
  public static apiDailyNavPartialUpdate(
    id: number,
    data: DailyNavRecordUpdate
  ): CancelablePromise<DailyNavRecordUpdate> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/daily-nav/{id}/',
      path: {
        id: id,
      },
      body: data,
    });
  }
}
